const { useTheme, useMediaQuery } = require('@mui/material');

const useCurrentBreakpoint = () => {
  const theme = useTheme();
  const belowSm = useMediaQuery(theme.breakpoints.down('sm'));
  const betweenSmMd = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const betweenMdLg = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const betweenLgXl = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const aboveXl = useMediaQuery(theme.breakpoints.up('xl'));

  if (belowSm) return 'xs';
  if (betweenSmMd) return 'sm';
  if (betweenMdLg) return 'md';
  if (betweenLgXl) return 'lg';
  if (aboveXl) return 'xl';
};

export default useCurrentBreakpoint;
